// components/LoadingSpinner.jsx
import { Spin } from "antd";

const LoadingSpinner = () => {
  return (
    <div style={{
      height: "100vh",
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    }}>
      <Spin size="large" tip="Loading..." />
    </div>
  );
};

export default LoadingSpinner;
